import {avatarFetchers} from '@contentlab/api/avatars';
import useReactQuery from '@/hooks/use-react-query';

export const useAvatarsQuery = () => {
  return useReactQuery({
    queryKey: ['avatars'],
    queryFn: avatarFetchers.getAvatars,
  });
};

export default useAvatarsQuery;
